import { DeleteKEKOfferFromSystem, DeleteKEKOfferFromSystemVariables } from "_graphql/mutation/kek/__generated__/DeleteKEKOfferFromSystem";
import {
  DeleteOfferFromSystem,
  DeleteOfferFromSystemVariables,
} from "_graphql/mutation/__generated__/DeleteOfferFromSystem";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import clsx from "clsx";
import config from "config";
import { deleteOfferFromSystem } from "_graphql/kek/mutation/index.kek";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function RemoveContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {

  const searchParams = useSearch<LocationGenerics>();
  const [remove, { loading }] = useMutation<
    DeleteKEKOfferFromSystem,
    DeleteKEKOfferFromSystemVariables
  >(deleteOfferFromSystem, {
    refetchQueries: ["Offers"],
  });

  const handleSubmit = async () => {
    await remove({
      variables: {
        offerId: searchParams?.id || "",
      },
    }).then(({ data }) => {
      if (data?.deleteOfferFromSystem) {
        toast.success("Offer Removed Successfully");
        refetch?.();
        setOpen?.(false);
      } else {
        toast.error("Could not remove offer");
      }
    });
  };

  return (
    <PopUp
      open={open}
      setOpen={setOpen}
      title={clsx({
        "Delete Offer": config.appDomain === "Visal",
        "Cancel Offer": config.appDomain === "KEK",
      })}
      cancelText={clsx({
        "No, Don't Delete Offer": config.appDomain === "Visal",
        "No, Don't Cancel Offer": config.appDomain === "KEK",
      })}
      description="This action would completely remove offer details from system"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={handleSubmit}
          >
            {(clsx({
              "Deleting Offer...": loading,
              "Delete Offer": !loading && config.appDomain === "Visal",
              "Cancel Offer": !loading && config.appDomain === "KEK",
            }))}
          </button>
        </>
      )}
    />
  );
}
